import { jsx as _jsx } from "react/jsx-runtime";
import useStyles from './styles';
const AppBadge = ({ color = 'magenta', style = {}, children }) => {
    const { classes } = useStyles();
    const stylesByColor = {
        grey: {
            backgroundColor: '#E0E0E0',
            color: '#000000'
        },
        magenta: {
            backgroundColor: '#FAE4EE',
            color: '#7B004C'
        }
    };
    return (_jsx("div", Object.assign({ className: classes.AppBadge, style: Object.assign(Object.assign({}, stylesByColor[color]), style) }, { children: children })));
};
export default AppBadge;
//# sourceMappingURL=index.js.map